import { decodeHtmlEntities } from 'shared/utils/textFormatters/textFormatters';

import type {
    SpendProductRowDto,
    SpendProductsResponseDto,
} from '../types/ReportSpendSummarySchema';

const normalizeProduct = (product: SpendProductRowDto): SpendProductRowDto => ({
    ...product,
    itemName: decodeHtmlEntities(product.itemName),
    brand: decodeHtmlEntities(product.brand ?? ''),
});

export const normalizeSpendProductsResponse = (
    response: SpendProductsResponseDto,
): SpendProductsResponseDto => ({
    ...response,
    items: (response.items ?? []).map(normalizeProduct),
});
